export default "__VITE_PUBLIC_ASSET__04251396__"